import { getLink } from '../../../../utils/utils';

const content = {
	rus: (
		`
		<div style="text-align: justify;">
		
			<p class="mb-3 bold">Действующие лица:</p>

			<p class="mb-1">
				1. Она - женщина 30-50 лет
			</p>
			<p class="mb-5">
				2. Он - мужчина 30-50 лет
			</p>

			<p class="italic mb-3">
				(Кафе у моря. Столики с пёстрыми зонтиками, стулья, полосатые тенты, флаги. Ярко светит солнце. Время от времени слышатся крики чаек и популярная музыка далёкого оркестра).
			</p>

			<p class="italic mb-3">
				<span class="bold">Он</span> (входит с небольшой сумкой и газетой. Садится за столик, вынимает из сумки термос и чашки, ставит их на стол. Начинает перелистывать газету. Читает. <br/>
				Пока он читает, входит <span class="bold">Она</span> и садится за тот же стол. В руке у неё листовка. Оба в летних одеждах; возможно, в солнцезащитных очках).
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Как тебе жара? Передавали, что поднимется до тридцати пяти в тени.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Ну и зачем? Лучше бы она упала до минус тридцати пяти, чтобы повымерзли все блохи. А при такой погоде они только всё больше размножаются.
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Вижу, тебя не задержали?
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Нет. Они поставили заслоны вокруг вокзала, но я показала им своё удостоверение, и они пропустили меня.
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Наверное, они ждут ещё один переполненный поезд с севера.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Возможно. Но зачем они бегут сюда? У моря не лучше, чем внутри страны. Даже опасней, из-за крыс с кораблей.
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Просто люди впадают в панику и бегут. А побережье всегда кажется более надёжным местом, более здоровым… Напряжение растёт. Люди кидаются куда глаза глядят, и при этом ещё больше разносят инфекцию. Бог знает, что будет, если скоро не откроют вакцину. Может, начнут отстреливать людей на улицах, как бродячих собак. И Санитарные Патрули станут арестовывать каждого, кто привлечёт их внимание. <br/>
				<span class="italc">(Разливает кофе по чашкам)</span> А мы сидим здесь и пьём кофе под музыку далёкого оркестра, в то время, как вокруг свирепствует чума. Объясни мне, как это можно наслаждаться кофе, в то время как ум осознаёт, что вокруг царит чума?
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Не знаю… Я знаю только, что всё нужно готовить на кипячёной воде… А что ещё можно делать? Что, есть другой выход? Мы бессильны что-то изменить; так что же остаётся, кроме как стараться жить как можно более нормально?
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Ну, так думаем ты да я; но большинство другого мнения. Ты видишь, как люди на глазах деградируют? Обвиняют соседей в сокрытии симптомов. Дети доносят на родителей. Все нервные. Любой, кто привлекает к себе внимание, навлекает на себя подозрение. Скоро кончится тем, что будут убивать без суда и следствия всех, кто, например, носит жёлтые ботинки или у кого уши торчат!
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Да, ты прав… А сколько появилось новых культов, обрядов, сект! Каждый день что-то новое. Можно подумать, что искать знамения на небе важнее, чем вакцину против болезни.
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Читала утреннюю газету? О событиях на севере? Люди бичуют сами себя. Им мало выходить на улицы и терзать себя плетями и иглами. Теперь они говорят, что они не просто искупают свои грехи – но что они Армия святых, священное войско, которое будет править миром тысячу лет. Они ждут помощи с неба. Они говорят, что могут изгонять из людей дьявола, поднимать больных и воскрешать мёртвых. Один их них утверждает, что сам воскрес из мёртвых! Самое худшее, что они кочуют с места на место, привлекая к себе массы народа и тем самым ещё больше разнося заразу! Войска приведены в боеготовность.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Ты об этом? <span class="italic">(Показывает листовку)</span>
			</p>

			<p class="mb-3">
				<span class="bold">Он</span> <span class="italic">(читает вслух)</span><span class="bold">:</span> «Святые Мстители Господни уже среди нас. Мы – орудие Гнева Господня. Гнев Господен настигнет каждого грешника. Готовься встретить Мстителя, которого Господь посылает тебе. Это может быть мужчина или женщина, стоящие рядом с тобой, пока ты читаешь это». Совершенно безумные люди. Будем надеяться, что они не придут к власти.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Тихо звучит музыка отдалённого оркестра)</span>
			</p>


			<p class="mb-1">
				<span class="bold">Она:</span> Одна из моих коллег ушла с работы в библиотеке, чтобы помогать проводить круглосуточные богослужения о спасении от чумы. Ну, я думаю, что если мы боремся со смертельной болезнью, от которой нет лекарства и нет даже надежды найти лекарство, то никакое средство не покажется странным. Нужно просто делать, что хочешь. Всё зависит от тебя. Можешь выбирать: или тебя тянут к краю колодца, и ты кричишь, протестуя против несправедливости жизни, но тебя всё равно швыряют головой вниз… или же ты сам подходишь к краю колодца и спускаешься в темноту по лесенке, неторопливо и с остатками достоинства… Результат в обоих случаях одинаков. Разница в тебе самом…
			</p>

			<p class="mb-3">
				<span class="bold">Он:</span> Ты права. Я думаю, что то, что отличает нас от кроликов и лошадей – это как раз способность думать, что мы можем сами определять свои пути к общему для всех концу. 
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Пауза. Пьёт кофе)</span>
			</p>


			<p class="mb-3">
				Я пытался купить тебе медовый пирог, твой любимый, но опоздал, всё распродали.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Пауза. Издали слышен усиленный громкоговорителем патетический голос оратора. Слова неразборчивы)</span>
			</p>


			<p class="mb-3">
				<span class="bold">Он:</span> Что там? Ещё один, кто вещает о Страшном Суде! Люди больше не способны выносить свою жизнь, и злятся на то, что не могут забыть, что они ещё живы.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Пауза)</span>
			</p>


			<p class="mb-1">
				<span class="bold">Он:</span> Помнишь день, когда мы встретились? У моря? Мы сидели за таким же столом, застеленным белой с голубым скатертью. Тогда нам удалось заказать медовый пирог… И я помню, что солнечные блики на море почти ослепили нас.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Да… Это было всего полгода назад… Тогда мы оба пытались смириться с тем, что случилось с нашими семьями. Мне казалось, что я не смогу жить, зная, что никогда больше не увижу своих детей.
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> По крайней мере ты знаешь, что они в безопасности за границей, хоть и далеко от тебя. По нынешним временам, лучше быть подальше от тех, кого любишь
			</p>

			<p class="mb-3">
				<span class="bold">Она:</span> Да, но и чума не стоит на месте. Когда-нибудь она настигнет и их. Я не могу не думать об этом. Тебе легче – ты уже всех потерял.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Пауза. Далёкие голоса и музыка ещё слышны)</span>
			</p>


			<p class="mb-1">
				<span class="bold">Она:</span> А помнишь наши споры о том, что делать, когда нас настигнет чума? Тогда все считали, что спастись можно только бегством.
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Да. Бежать – или остаться, чтобы встретить её лицом к лицу? Сопротивляться или сдаться? Сопротивляться гибели, разрушению всего человеческого: сознания, нежности, способности удивляться. Да, я помню.
			</p>

			<p class="mb-3">
				<span class="bold">Она:</span> Уже тогда мы предвидели, что всё человеческое будет уничтожено безмозглыми бактериями, что ничего не останется от наших семей, от всего, что придаёт ценность нашей жизни: от музыки, литературы, науки… Всё погибнет в хаосе, разрушенное бродячими безумцами, которые живут как чумные крысы в домах, где раньше поливали цветы и устраивали детские праздники. Мы видели это в будущем; а теперь это наше настоящее.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Пауза)</span>
			</p>


			<p class="mb-3">
				<span class="bold">Он:</span> <span class="italic">(здоровается с проходящим за сценой)</span> Добрый день! Да, жарко сегодня. Да, будем надеяться. Всего хорошего.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Пауза. Оба провожают глазами проходящую женщину)</span>
			</p>


			<p class="mb-1">
				<span class="bold">Он:</span> Вот она. Каждый день она ходит на кладбище с этой корзинкой.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Это та, что каждый день сидит на могиле мужа?
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Да, приносит термос, чашку и блюдце. Садится у могилы и пьёт кофе. Каждый день часа по три-четыре.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Зачем это ей?
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Общается с мёртвым. Каждый день – с тех пор, как он умер; а было это больше года назад. Тогда ещё можно было купить гроб; сейчас их уже не успевают делать.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> И что она говорит мертвецу?
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Это называется «неисцелимая душевная рана». Или же «неугасимая ненависть». Она изливает на его могилу всё презрение и злобу, которые копились в ней сорок лет. Злобу на него за то, что всю жизнь он подчинял её своей воле, и презрение к себе за то, что она подчинялась… И вот теперь она сводит счёты. Как в конторской книге: за каждое слово, каждый поступок выписывает квитанцию к оплате. Этого труда ей хватит до конца жизни.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Откуда ты это знаешь?
			</p>

			<p class="mb-3">
				<span class="bold">Он:</span> По-моему, хорошие отношения не оставили бы столько открытых счетов. Хорошие отношения позволяют людям оставить друг друга в покое после смерти. Но эти двое накопили столько подавленной жизни, что она сейчас вырывается с неудержимой энергией и не отпускает её. Недосказанное при жизни питает её силы приходить сюда и пить кофе. Ну, и это помогает ей выживать. Хоть чем-то занимать свои дни. Нам всем сейчас нужно занимать чем-то свои дни. Вот как мы сейчас пьём кофе. Когда-то, до чумы, это было обычным ежедневным удовольствием: пить кофе. Но теперь это «как обычно» стало вдруг очень важным. Это не вызов чуме. Как можно сражаться с неизбежным? Просто это «как обычно» - единственное, что нам осталось.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Звуки далёкого оркестра)</span>
			</p>


			<p class="mb-3">
				<span class="bold">Она:</span> Да, и ничего больше. Когда всё распадается – единственной защитой остаётся привычка. Я продолжаю работать в библиотеке: расставляю книги, веду каталог, заказываю новые поступления – хотя за ними никто не приходит, боясь заразиться. А ты всё так же переводишь, даже если твои переводы никто не напечатает и не прочтёт. Можно говорить, что всё это бессмысленно, абсурдно. Но именно это мы делали и должны делать дальше. И именно в наше время.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Оратор вдали замолкает)</span>
			</p>


			<p class="mb-3">
				<span class="bold">Он:</span> Чума хочет превратить нас в беженцев, гонимых ужасом, которые бегут, всё время оглядываясь, не нависает ли она уже над нашими плечами. Но мы с тобой выбрали кое-что получше. Просто сидеть за столом и спокойно беседовать.
			</p>


			<p class="mb-3 text-center">
				<span class="italic">(Пауза)</span>
			</p>


			<p class="mb-1">
				<span class="bold">Она:</span> Вчера в библиотеке говорили, что некоторые ароматы помогают против чумы: жасмин, ладан, розмарин, можжевельник…
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Разве чуму этим отгонишь! Но ты права насчёт запаха можжевельника: это что-то незабываемое. Одна веточка наполняет своим ароматом всю комнату.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Можжевельник всегда такой жилистый, пружинистый. Обнимешь его – а он сразу оттолкнёт своими колючками. Он любит волю, простор.
			</p>

			<p class="mb-3">
				<span class="bold">Он:</span> Да, простор… В горах ничего не растёт, только камень да земля бесплодная. Лишь можжевельник в трещинах скал.
			</p>


			<p class="mb-3 text-center">
				<span class="italic">(Далёкий звук выстрела. ОН смотрит на часы)</span>
			</p>


			<p class="mb-1">
				<span class="bold">Он:</span> Точно! Вовремя! Вот это они умеют: каждый час стрелять из пушки. И верить, что порох очищает воздух…
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Ну что ты удивляешься! Люди хватаются за малейшую опору, даже если знают, что она фальшивая.
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> И как мило власти идут им навстречу! Они будут делать и более бессмысленные вещи, лишь бы не было паники и бунта. <br/>
				<span class="italic">(Говорит с кем-то за сценой):</span> Добрый день! Как жена? Хорошо. Да, спасибо. Ну и жара сегодня! Спасибо, вам также. Всего хорошего. До свидания.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Он на почту?
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> Да, одержимость. Каждый день он ходит на почту узнать, не пришёл ли патент на его изобретение. Подумать только! В наше время, когда все силы брошены на спасение от кризиса, и ни на что другое нет ни времени, ни денег! А он всё ещё не может понять, что никого не интересуют ни он, ни его изобретение, на которое он потратил всю жизнь. Не может снять с себя бремя своего творения. Так и будет нести его до конца.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> Да, наверно. Собственная история давит всё больше и больше, и в конце концов раздавит тебя, если ты не сбросишь её. У меня такое чувство тяжести, когда я вспоминаю свою жизнь до чумы! Всё в этой жизни имеет свой вес и отбрасывает свою тень. Но теперь, при чуме, все контуры видятся очень резко, но ничто не отбрасывает тени. Никто не спрашивает о смысле. Никого не интересуют причины и следствия. Ведь всё очевидно. Ясно, что всё прошлое нужно забыть. Чума ничего нам не обещает. Ничего не даёт. Она двухмерна… Да, есть выбор. Можно только скользить по поверхности вещей, легко и слегка; а можно погружаться в глубины и открывать секреты Природы… но конец один. И знание, и незнание приводят к одному и тому же. Пока я жила, я не понимала этого. Но теперь я чувствую себя такой освобождённой, такой лёгкой… как бабочка на летнем ветерке.
			</p>

			<p class="mb-3">
				<span class="bold">Он:</span> А мне чума дала падение преград… простор вокруг… Знаешь, я родился недалеко отсюда, и в двадцать лет ушёл из дому, чтобы поймать удачу. А вернулся только полгода назад, когда вся моя семья уже умерла. Я тогда пошёл прогуляться среди холмов, посмотреть на можжевельник, послушать жаворонков... Я шёл по тропинке, с одной стороны которой стояла высокая старая стена. Я помнил её ещё с детства, помнил, где камни лежали неровно, где были выщербинки или жёлтые пятна лишайника… Я часто вспоминал эту стену. Она стояла здесь, наверно, столетия… Для меня она стояла всегда. И вот я подходил уже к этой стене, и видел, что она такая же, как была в детстве. Но в каких-то двух метрах от меня, она вдруг рухнула и рассыпалась. Сама по себе: ничто вокруг не шевельнулось. Мне стало страшно. Но впервые в жизни я увидел то, что было за стеной.
			</p>


			<p class="mb-3 text-center">
				<span class="italic">(Пауза)</span>
			</p>


			<p class="mb-1">
				<span class="bold">Она:</span> Да… чтоб что-то увидеть, часто нужно убрать преграду… или осушить океан. Как раз этим я занималась последние полгода. Я осушила целый океан. И когда шум волн замолк, я смогла первый раз в жизни услышать…
			</p>

			<p class="mb-1">
				<span class="bold">Он:</span> И что же ты услышала?
			</p>

			<p class="mb-3">
				<span class="bold">Она:</span> Крик, страшный душераздирающий вопль. Я назвала его «моя жизнь», потому что вся моя жизнь, хотя я раньше и не знала этого, была этим непрестанным ужасным криком. Но сейчас я услышала его. Страх и гнев были в этом крике. Это был голос ребёнка… того ребёнка, который должен был стать мной, но которому не позволили родиться. Но сейчас этот крик вырвался на волю. Чума освободила его. И он заполняет собой весь космос, летя к далёким планетам, и ничто не может остановить его, даже если завтра чума убьёт меня. Этот крик – отрицание смерти. И человек, которым должен был стать этот ребёнок, наконец родился. Чума родила его.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Пауза. Звуки далёкого оркестра)</span>
			</p>


			<p class="mb-3">
				<span class="bold">Он:</span> Смотри, ястреб… Он пари́т не двигаясь с места, несмотря на порывистый ветер… Как это у него получается?
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Пауза)</span>
			</p>


			<p class="mb-1">
				<span class="bold">Он:</span> Чума не пришла к нам извне. Смерть и болезни вокруг нас – это только огонь, сжигающий сухую траву. Настоящая чума – внутри нас. И единственный способ победить её – принять это и понять, а для этого нужно, чтоб было широко вокруг. В обычной жизни мало пространства. Мы зажаты в тиски между прошлым и будущим. Нам негде повернуться, нам больно – но мы не можем себе представить, что есть другая жизнь. Но иногда стены рушатся… тиски разжимаются… и внезапно исчезают прошлое и будущее, и остаётся только то, что сейчас. У нас больше нет времени – зато есть пространство, безграничный простор. А в пространстве нет настоящего и будущего, а значит – нет смерти.
			</p>

			<p class="mb-1">
				<span class="bold">Она:</span> И что ты увидел там, в твоём просторе?
			</p>

			<p class="mb-3">
				<span class="bold">Он:</span> Я понял, что всё, что существует, всё, что делает человек, всякая секунда жизни – уникальны. Тень твоей руки на столе, форма этих камешков на тротуаре, солнечные блики на морских волнах – всё это бывает только раз во всей Вселенной, и мы с тобой – единственные живые существа в вечности, которые сознают это. И я понимаю, что моя жизнь, в которой я смог осознать это – чудесна, совершенна и счастлива.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Воет корабельная сирена)</span>
			</p>
			

			<p class="mb-3">
				<span class="bold">Он:</span> Ещё корабль пришёл. Свалка на пристани. Людей как муравьёв. Идём лучше по домам. Сейчас Санитарные Патрули начнут искать иммигрантов. Эти Патрули всё больше звереют. Когда приходит корабль, безопаснее сидеть дома.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Собирает термос и чашки)</span>
			</p>
			

			<p class="mb-1">
				Так что встретимся завтра, как обычно.
			</p>
			
			<p class="mb-3">
				<span class="bold">Она:</span> Нет. Я завтра не приду. Мы больше не встретимся. Я нашла у себя пятно на коже.
			</p>

			
			<p class="mb-3 text-center">
				<span class="italic">(Пауза, пока до него доходит смысл сказанного)</span>
			</p>
			

			<p class="mb-1">
			<span class="bold">Он:</span> Понимаю… Да-да, понимаю…
			</p>
			
			<p class="mb-1">
				<span class="bold">Она:</span> Да. Жаль, но это так.
			</p>

			<p class="mb-1">
			<span class="bold">Он:</span> Значит, и мне осталось недолго.
			</p>
			
			<p class="mb-3">
				<span class="bold">Она:</span> Наверно.
			</p>
			

			<p class="mb-3 text-center">
				<span class="italic">(Пауза)</span>
			</p>

			
			<p class="mb-1">
				<span class="bold">Она:</span> Не надо слов. Всё понятно. Мы не вправе требовать от жизни больше.
			</p>

			<p class="mb-1">
			<span class="bold">Он:</span> Ты права. Нельзя требовать больше. Давай прогуляемся вдоль берега и посмотрим на море. Морской воздух полезен…
			</p>
			
			<p class="mb-3">
				<span class="bold">Она:</span> Да-да, давай. Идём посмотрим на море.
			</p>
			
			
			<p class="mb-3 text-center">
				<span class="italic">(Уходят вместе)</span>
			</p>


			<p class="bold text-center text-uppercase">Конец</p>
		</div>
		`
	)
}

const itemName = {
	rus: `Чума`
}

const itemAuthor = {
	rus: `Автор: Гарольд Браун, 1992<br/>
		Перевод Татьяны Аудерской, 2016
	`
}

const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus,
		itemContent: content.rus,
		itemAuthor: itemAuthor.rus
	}
}

export default item;